import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {OldAppInfoDialogComponent} from '../old-app-info-dialog/old-app-info-dialog.component';

@Component({
	selector: 'app-old-version-flag',
	templateUrl: './old-version-flag.component.html',
	styleUrl: './old-version-flag.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class OldVersionFlagComponent {
	constructor(private dialog: MatDialog) {}

	openInfo() {
		this.dialog.open(OldAppInfoDialogComponent);
	}
}
